import { http } from '@pendo/http';
import isFunction from 'lodash/isFunction';

export function isZendeskEnabledForPath (urlPath) {
    // Invitation page URLs contain sensitive information that we
    // don't want sent to any third parties (see APP-105871)
    if (/^\/invitation\/confirm/.test(urlPath)) {
        return false;
    }

    // Registration page URLs contain sensitive information that we
    // don't want sent to any third parties (see APP-126695)
    if (/^\/register\/(?:complete|resetpassword)/.test(urlPath)) {
        return false;
    }

    return true;
}

// Install Zendesk on Pendo Internal
export function setupZendeskSnippetForPendoInternal () {
    let src = '';
    if (process.env.VUE_APP_ENV_IS_PROD === 'true' || window.appEnvId === 'test') {
        src = 'https://static.zdassets.com/ekr/snippet.js?key=f0fac6b4-cd6f-4dc4-a20e-3becb43e4c8a';
    } else if (window.appEnvId === 'dev') {
        src = 'https://static.zdassets.com/ekr/snippet.js?key=dc4afdde-f15e-4734-822a-ff35c717c3cf';
    }

    if (src) {
        (() => {
            const script = window.document.createElement('script');
            script.type = 'text/javascript';
            script.id = 'ze-snippet';
            script.async = true;
            // Hide the Zendesk widget by default bc we segment it to premium customers.
            // The segmented RC Zendesk-Chat extension module will then handle visiblity
            script.onload = () => {
                if (!isFunction(window.zE)) return;
                window.zE('webWidget', 'hide');
            };
            script.src = src;
            window.document.getElementsByTagName('body')[0].appendChild(script);
        })();
    }

    window.pullZendeskChatJwt = function () {
        return http.post('/api/s/_SID_/zendesk-internal/chat/jwt').then((res) => res.data);
    };
}
